import React from 'react'
import dynamic from 'next/dynamic'
import { useController, UseControllerProps } from 'react-hook-form'
import Checkbox from './Checkbox'

// @ts-ignore
const Slider = dynamic(() => import('./Slider'), { ssr: false })

type SliderCheckboxProps = {
  id: string
  label: string
  min?: number
  max?: number
  suffix?: string
}

function SliderCheckbox(props: SliderCheckboxProps & UseControllerProps) {
  const [isChecked, setChecked] = React.useState<boolean>(false)
  const { id, label, suffix, min, max, ...controlProps } = props

  const {
    field: { onChange, value },
  } = useController(controlProps)

  React.useEffect(() => {
    if (isChecked) {
      onChange([min, max])
    } else {
      onChange(undefined)
    }
  }, [isChecked])
  return (
    <div className="mb-12 flex flex-col">
      <Checkbox
        label={label}
        value={isChecked}
        onChange={(event) => setChecked(event.target.checked)}
        className="mb-4"
      />
      {/* @ts-ignore */}
      <Slider
        disabled={!isChecked}
        suffix={suffix}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}

export default SliderCheckbox
